import { tTableHead } from 'types/components/table';

export const tableHead: tTableHead[] = [
  {
    sortable: false,
    name: 'No.',
    key: 'order',
  },
  {
    sortable: false,
    name: 'Name and surname',
    key: 'userNameAndSurname',
  },
  {
    sortable: false,
    name: 'Position',
    key: 'userPosition',
  },
  {
    sortable: false,
    name: 'Employer',
    key: 'userEmployer',
  },
  {
    sortable: false,
    name: 'Phone number',
    key: 'userPhoneNumber',
  },
  {
    sortable: false,
    name: 'E-mail',
    key: 'userEmail',
  },
];

export const searchableFields = [
  'first_name',
  'last_name',
  'position',
  'company',
  'phone_number',
  'email',
];
